import { ColumnsType } from '@setvi/shared/types';
import { Customer } from 'Services/Mongo/Types';
import {
  ProductColumn,
  ProductDetailsColumnsIds,
  ProductInventory
} from '@setvi/shared/interfaces';
import { getWarehouseLocation } from 'componentsV2/product/details/content/subpages/warehouse/useWarehouseColumns';
import { getWarehouseCellContent } from './content';

interface useWarehouseColumnsProps {
  selectedCustomer?: Customer;
  configColumns: ProductColumn[];
}

export const useWarehouseColumns = ({
  selectedCustomer,
  configColumns = []
}: useWarehouseColumnsProps) => {
  const warehouseColumns: ColumnsType = configColumns.map(column => ({
    ...column,
    cellContent: (row: ProductInventory) =>
      getWarehouseCellContent({
        label: column.label,
        id: column.id as ProductDetailsColumnsIds,
        row,
        selectedCustomer,
        getWarehouseLocation
      })
  }));

  return {
    warehouseColumns
  };
};
